let sources = {
  cat: {
    category: 'Cat',
    items: [
    { id: 1, path: 'cat1.jpeg', slug: 'aB0', copyURL: 'https://seta.uz/aB0' },
    { id: 2, path: 'cat2.jpeg', slug: '9yx', copyURL: 'https://seta.uz/9yx' },
    { id: 3, path: 'cat3.jpeg', slug: 'Z04', copyURL: 'https://seta.uz/Z04' },
    { id: 4, path: 'cat4.jpeg', slug: '0my', copyURL: 'https://seta.uz/0my' },
    { id: 5, path: 'cat5.jpeg', slug: 'Q02', copyURL: 'https://seta.uz/Q02' },
    { id: 6, path: 'cat6.jpeg', slug: 'b7y', copyURL: 'https://seta.uz/b7y' },
    { id: 7, path: 'cat7.jpeg', slug: 'k01', copyURL: 'https://seta.uz/k01' },
    { id: 8, path: 'cat8.jpeg', slug: '8Xy', copyURL: 'https://seta.uz/8Xy' },
    { id: 9, path: 'cat9.jpeg', slug: 'P30', copyURL: 'https://seta.uz/P30' },
    { id: 10, path: 'cat10.jpeg', slug: 'ry5', copyURL: 'https://seta.uz/ry5' },
    { id: 11, path: 'cat11.jpeg', slug: 'T90', copyURL: 'https://seta.uz/T90' },
    { id: 12, path: 'cat12.jpeg', slug: 'f2y', copyURL: 'https://seta.uz/f2y' },
    { id: 13, path: 'cat13.jpeg', slug: 'L06', copyURL: 'https://seta.uz/L06' },
  ],
  },
  cow: {
    category: 'Cow',
    items: [
    { id: 1, path: 'cow1.jpeg', slug: 'y7y', copyURL: 'https://seta.uz/y7y' },
    { id: 2, path: 'cow2.jpeg', slug: 'D0b', copyURL: 'https://seta.uz/D0b' },
    { id: 3, path: 'cow3.jpeg', slug: 'wy4', copyURL: 'https://seta.uz/wy4' },
    { id: 4, path: 'cow4.jpeg', slug: 'H30', copyURL: 'https://seta.uz/H30' },
    { id: 5, path: 'cow5.jpeg', slug: 'c8y', copyURL: 'https://seta.uz/c8y' },
  ],
  },
  dog: {
    category: 'Dog',
    items: [
    { id: 1, path: 'dog1.jpeg', slug: 'R10', copyURL: 'https://seta.uz/R10' },
    { id: 2, path: 'dog2.jpeg', slug: 'm5y', copyURL: 'https://seta.uz/m5y' },
    { id: 3, path: 'dog3.jpeg', slug: 'V60', copyURL: 'https://seta.uz/V60' },
    { id: 4, path: 'dog4.jpeg', slug: 'n2J', copyURL: 'https://seta.uz/n2J' },
    { id: 5, path: 'dog5.jpeg', slug: 'U70', copyURL: 'https://seta.uz/U70' },
    { id: 6, path: 'dog6.jpeg', slug: 'x9L', copyURL: 'https://seta.uz/x9L' },
    // { id: 7, path: 'dog7.jpeg', slug: 'B0y', copyURL: 'https://seta.uz/B0y' },
    { id: 8, path: 'dog8.jpeg', slug: 's3Q', copyURL: 'https://seta.uz/s3Q' },
    { id: 9, path: 'dog9.jpeg', slug: 'F8t', copyURL: 'https://seta.uz/F8t' },
    { id: 10, path: 'dog10.jpeg', slug: 'd6M', copyURL: 'https://seta.uz/d6M' },
    { id: 11, path: 'dog11.jpeg', slug: 'K4w', copyURL: 'https://seta.uz/K4w' },
    { id: 12, path: 'dog12.jpeg', slug: 'p10', copyURL: 'https://seta.uz/p10' },
    { id: 13, path: 'dog13.jpeg', slug: 'G7v', copyURL: 'https://seta.uz/G7v' },
  ],
  },
  monkey: {
    category: 'Monkey',
    items: [
    { id: 1, path: 'monkey1.jpeg', slug: 'e2C', copyURL: 'https://seta.uz/e2C' },
    { id: 2, path: 'monkey2.jpeg', slug: 'N9y', copyURL: 'https://seta.uz/N9y' },
    { id: 3, path: 'monkey3.jpeg', slug: 'h5Z', copyURL: 'https://seta.uz/h5Z' },
    { id: 4, path: 'monkey4.jpeg', slug: 'S0y', copyURL: 'https://seta.uz/S0y' },
    { id: 5, path: 'monkey5.jpeg', slug: 't30', copyURL: 'https://seta.uz/t30' },
    { id: 6, path: 'monkey6.jpeg', slug: 'W6y', copyURL: 'https://seta.uz/W6y' },
    { id: 7, path: 'monkey7.jpeg', slug: 'v10', copyURL: 'https://seta.uz/v10' },
    { id: 8, path: 'monkey8.jpeg', slug: 'C8y', copyURL: 'https://seta.uz/C8y' },
  ],
  },
  gorilla: {
    category: 'Gorilla',
    items: [
    { id: 1, path: 'gorilla1.jpeg', slug: 'j20', copyURL: 'https://seta.uz/j20' },
    { id: 2, path: 'gorilla2.jpeg', slug: '3niJ', copyURL: 'https://seta.uz/3niJ' },
  ],  
  },
  penguin: {
    category: 'Penguin',
    items: [
    { id: 1, path: 'penguin1.jpeg', slug: 'q70', copyURL: 'https://seta.uz/q70' },
    { id: 2, path: 'penguin2.jpeg', slug: 'M0y', copyURL: 'https://seta.uz/M0y' },
  ],
  },

  xamster: {
    category: 'Hamster',
    items: [
    { id: 1, path: 'xamster1.jpeg', slug: 'z50', copyURL: 'https://seta.uz/z50' },
    { id: 2, path: 'xamster2.jpeg', slug: 'A3y', copyURL: 'https://seta.uz/A3y' },
  ],
  },

  rabbit: {
    category: 'Rabbit',
    items: [
    { id: 1, path: 'rabbit1.jpeg', slug: 'f09', copyURL: 'https://seta.uz/f09' },
  ],
  },

  sheep: {
    category: 'Sheep',
    items: [
    { id: 1, path: 'sheep1.jpeg', slug: 'D2y', copyURL: 'https://seta.uz/D2y' },
  ],
  },

  duck: {
    category: 'Duck',
    items: [
    { id: 1, path: 'duck1.jpeg', slug: 'n60', copyURL: 'https://seta.uz/n60' },
  ],
  },

  donkey: {
    category: 'Donkey',
    items: [
    { id: 1, path: 'donkey1.jpeg', slug: 'Pw1', copyURL: 'https://seta.uz/Py1' },
  ],
  },

  horror: {
    category: 'Horror',
    items: [
    { id: 1, path: 'horror1.jpeg', slug: 're0', copyURL: 'https://seta.uz/re0' },
    { id: 2, path: 'horror2.jpeg', slug: 'V7y', copyURL: 'https://seta.uz/V7y' },
    { id: 3, path: 'horror3.jpeg', slug: 'sq0', copyURL: 'https://seta.uz/sq0' },
    { id: 4, path: 'horror4.jpeg', slug: 'pl0', copyURL: 'https://seta.uz/pl0' },
  ],
  }
};

export default sources;
